module.exports = __webpack_public_path__ + "img/plan.c98d10f.svg";